import { useSelector } from 'react-redux';
import { RootState } from '../types/graph';
import { useDetermineNewPatient } from './questionnaire.hooks';
import { useMemo } from 'react';

interface SessionInfo {
  referrer: RootState['referrer'];
  mode: RootState['graph']['mode'];
  variant: RootState['graph']['variant'];
  options: RootState['graph']['options'];
  newPatient: boolean;
  invitationFallback: boolean;
  practiceOnboardingDisplayMode: string | null | undefined;
  patientSegment: string | null;
}

export const useSessionInfo = (): SessionInfo => {
  const referrer = useSelector((state: RootState) => state.referrer);
  const mode = useSelector((state: RootState) => state.graph.mode);
  const variant = useSelector((state: RootState) => state.graph.variant);
  const options = useSelector((state: RootState) => state.graph.options);
  const newPatient = useDetermineNewPatient();
  const invitationFallback = useSelector(
    (state: RootState) => state.invitationFallback,
  );
  const practiceOnboardingDisplayMode = useSelector(
    (state: RootState) => state.consultation.practice?.onboardingDisplayMode,
  );
  const patientSegment = useSelector(
    (state: RootState) => state.patientSegment,
  );

  const sessionInfo = useMemo(
    () => ({
      referrer,
      mode,
      variant,
      options,
      newPatient,
      invitationFallback,
      practiceOnboardingDisplayMode,
      patientSegment,
    }),
    [
      referrer,
      mode,
      variant,
      options,
      newPatient,
      invitationFallback,
      practiceOnboardingDisplayMode,
      patientSegment,
    ],
  );

  return sessionInfo;
};
